import { IStaticPageItem } from '@ui';

export const data: IStaticPageItem[] = [
  {
    title: '',
    titleStyle: '',
    subTitle: '',
    description:
      'Thanks for signing up to Prontoclass! While we are in beta stage, continue using our services for free! Please help us to improve our product by completing the feedback form which can be accessed on the left-hand menu.',
    background: '',
    blocks: []
  }
];
